import { monitoringFiltersEnum } from '../enums/monitoring-filters.enum';

export class InvalidFiltersError extends Error {
    public filterTypes: monitoringFiltersEnum[];
    public invalidValues: string[];
    public localizedInvalidValueMap: Map<monitoringFiltersEnum, string[]>;

    constructor(m: string, type: monitoringFiltersEnum[], invalidValues?: string[]) {
        super(m + ' ' + type);
        this.filterTypes = type;
        this.invalidValues = invalidValues;
        // HACK: deals with Error resetting the prototype which makes the type incorrect
        Object.setPrototypeOf(this, InvalidFiltersError.prototype);
    }
}
